import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Link } from '../../types';

@Component({
  selector: 'nx-ng-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input()
  title = '';

  @Input()
  text = '';

  @Input()
  backgroundColour = '';

  @Input()
  textColour = '';

  @Input()
  link: Link | undefined = undefined;

  @Output()
  close: EventEmitter<void> = new EventEmitter<void>();

  handleCloseBanner() {
    this.close.emit();
  }
}
